import React, { useEffect, useState } from "react";
import {
  HandCoins,
  Paintbrush,
  SquareChartGantt,
  Combine,
  BicepsFlexed,
  Signature,
} from "lucide-react";

export const ServicesSection = () => {
  const [services, setServices] = useState([]);

  // Predefined icons to be assigned based on index
  const icons = [
    <HandCoins aria-hidden="true" />,
    <Paintbrush aria-hidden="true" />,
    <SquareChartGantt aria-hidden="true" />,
    <Combine aria-hidden="true" />,
    <BicepsFlexed aria-hidden="true" />,
    <Signature aria-hidden="true" />,
  ];

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(
          "https://webadmin.rigve.com/api/get_services",
        );
        const result = await response.json();
        if (result.status === 1) {
          setServices(result.data);
        } else {
          console.error("Failed to fetch services:", result.msg);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  return (
    <section
      id="services"
      className="py-16 bg-gray-50"
      aria-labelledby="services-heading"
    >
      <div className="max-w-7xl px-6 mx-auto">
        {" "}
        <div className="mb-4 text-center flex flex-col items-center">
          <h2 id="services-heading" className="fs-21 font-bold text-gray-900">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto my-4 rounded-full"></div>
        </div>
        {/* Services Grid */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="group bg-white rounded-2xl border border-gray-200 p-6 shadow-sm transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-orange-500 hover:bg-orange-50"
              aria-labelledby={`service-${service.id}`}
            >
              {/* Icon */}
              <div className="flex align-middle mb-3">
                <div className="icon_image flex items-center justify-center rounded-xl bg-gray-100 transition-all duration-300">
                  {icons[index % icons.length]}
                </div>
              </div>

              {/* Title */}
              <h3
                id={`service-${service.id}`}
                className="text-mg font-semibold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors"
              >
                {service.name}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
      {/* Section Header */}
    </section>
  );
};
